<template>
  <Modal
    :confirmationText="'Create user'"
    :darker="true"
    :headerTitle="'Add new user'"
    :isAboveAll="true"
    :showButtonLoader="loading"
    @closeModal="!loading && $emit('close')"
    @confirm="createNewSalesRep()"
  >
    <template #content>
      <div class="form-container">
        <label
          for="form-name"
          class="input-container"
          :class="{ error: modal_errors.name }"
        >
          <div class="sidebar-option-title">
            <span>Name</span>
          </div>
          <input
            id="form-name"
            class="input-style"
            type="text"
            v-model="modal_name"
            @input="modal_errors.name && checkForm(false)"
          />
          <span class="error-msg" v-if="modal_errors.name">Missing name</span>
        </label>
        <label
          for="form-email"
          class="input-container"
          :class="{ error: modal_errors.email }"
        >
          <div class="sidebar-option-title">
            <span>Email</span>
          </div>
          <input
            id="form-email"
            class="input-style"
            type="email"
            v-model="modal_email"
            @input="modal_errors.email && checkForm(false)"
          />
          <span class="error-msg" v-if="modal_errors.email">Missing Email</span>
        </label>
        <label
          for="form-phone"
          class="input-container"
          :class="{ error: modal_errors.phone }"
        >
          <div class="sidebar-option-title">
            <span>Phone (optional)</span>
          </div>
          <div class="flex justify-between phone-mask-container">
            <input
              class="text-center form-control form-control-solid rounded focus:border-blue-400 focus:shadow-outline"
              type="text"
              id="first"
              ref="modal_phone_1"
              maxlength="3"
              :value="modal_phone_1"
              @input="handlePhoneNumber(1, $event.target.value, $event)"
            />
            <input
              class="text-center form-control form-control-solid rounded focus:border-blue-400 focus:shadow-outline"
              type="text"
              id="second"
              ref="modal_phone_2"
              maxlength="3"
              :value="modal_phone_2"
              @input="handlePhoneNumber(2, $event.target.value, $event)"
            />
            <input
              class="text-center form-control form-control-solid rounded focus:border-blue-400 focus:shadow-outline"
              type="text"
              id="third"
              ref="modal_phone_3"
              :value="modal_phone_3"
              @input="handlePhoneNumber(3, $event.target.value, $event)"
            />
          </div>
        </label>
        <!-- Add Extension -->
        <span
          class="form-text text-muted my-2 show-extension-switch"
          id="add-phone-extension-switch"
          v-if="!showAddExtension"
          @click="showAddExtension = true"
          >Add Extension</span
        >
        <div class="extension-container align-items-center" v-else>
          <span>Extension:</span>
          <div class="input-container flex">
            <label>
              <input
                class="mt-2 text-center form-control form-control-solid rounded focus:border-blue-400 focus:shadow-outline"
                type="text"
                id="phone-ext-label"
                maxlength="10"
                v-model="modal_phone_extension_label"
              />
            </label>

            <label>
              <input
                class="mt-2 text-center form-control form-control-solid rounded focus:border-blue-400 focus:shadow-outline"
                type="text"
                id="phone-ext-number"
                maxlength="10"
                v-model="modal_phone_extension_number"
              />
            </label>
          </div>
          <span
            class="text-muted show-extension-switch"
            @click="showAddExtension = false"
            >Hide extension</span
          >
        </div>
      </div>

      <div class="rep-preview-container">
        <p class="text-info slate-light">
          Your contact info will be displayed as seen below on the cover of each
          Playbook and Snapsheet you create.
        </p>
        <div class="rep-info">
          <h3 class="slate-bold">{{ modal_name || "Name" }}</h3>
          <p class="slate-bold">{{ modal_email || "Email" }}</p>
          <p class="slate-bold">{{ phoneNumber || "(0000) 000-000" }}</p>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/Utils/Modal.vue";
import { mapActions } from "vuex";
export default {
  name: "CreateSalesRepModal",
  props: [
    "modalMode",
    "prepopulatedName",
    "modalEmail",
    "modalUserId",
    "modalPhone",
    "showBackdrop",
  ],

  components: { Modal },

  data() {
    return {
      modal_name: "",
      modal_email: "",
      modal_phone_1: "",
      modal_phone_2: "",
      modal_phone_3: "",
      modal_phone_extension_label: "Ext.",
      modal_phone_extension_number: "",
      showAddExtension: false,
      modal_errors: {},
      modal_user_id: "",
      loading: false,
    };
  },

  computed: {
    has_errors() {
      return Object.keys(this.modal_errors).length > 0;
    },
    phoneNumber() {
      const phone = `(${this.modal_phone_1}) ${this.modal_phone_2}-${this.modal_phone_3}`;

      return this.showAddExtension && this.modal_phone_extension_label && this.modal_phone_extension_number
        ? `${phone}  ${this.modal_phone_extension_label} ${this.modal_phone_extension_number}`
        : phone;
    },
  },

  methods: {
    ...mapActions("dealer", ["addNewSalesRep"]),

    checkForm: function (showToast = true) {
      this.modal_errors = {};
      //email
      if (!this.modal_email) {
        this.modal_errors.email = "Email required.";
      } else if (!this.validEmail(this.modal_email)) {
        this.modal_errors.email =
          "Valid email address required, e.g. mail@example.com";
      } else if (this.modal_email.length > 200) {
        this.modal_errors.email = "Email too long.";
      }

      if (!this.modal_name) {
        this.modal_errors.name = "Name required.";
      } else if (this.modal_name.length > 200) {
        this.modal_errors.name = "Name too long.";
      }

      if (!Object.keys(this.modal_errors).length) {
        return true;
      }

      showToast &&
        this.$store.dispatch("showToast", {
          txt: "Please verify your information is correct",
          type: "error",
        });
      return false;
    },

    handlePhoneNumber(i, newValue) {
      const oldValue = this[`modal_phone_${i}`];

      const focusOnInput = (i) => {
        this.$nextTick(() => {
          this.$refs[`modal_phone_${i}`].focus();
        });
      };

      //Check if we have to move on to the next input
      const FIRST_INPUT_LENGTH = 3;
      const SECOND_INPUT_LENGTH = 3;
      const THIRD_INPUT_LENGTH = 4;

      //Move to previuos input text if the new value is empty
      if (!newValue && i !== 1) {
        focusOnInput(i - 1);
        this[`modal_phone_${i}`] = newValue;
        return true;
      }

      switch (i) {
        case 1:
          if (newValue.length >= FIRST_INPUT_LENGTH) {
            this[`modal_phone_${i}`] = newValue;
            focusOnInput(2);
          } else if (newValue.length <= FIRST_INPUT_LENGTH) {
            this[`modal_phone_${i}`] = newValue;
          } else {
            this[`modal_phone_${i}`] = oldValue;
          }
          break;
        case 2:
          if (newValue.length >= SECOND_INPUT_LENGTH) {
            this[`modal_phone_${i}`] = newValue;
            focusOnInput(3);
          } else if (newValue.length <= SECOND_INPUT_LENGTH) {
            this[`modal_phone_${i}`] = newValue;
          } else {
            this[`modal_phone_${i}`] = oldValue;
          }
          break;
        case 3:
          //Do not allow third input to go up to 4 characters
          if (newValue.length <= THIRD_INPUT_LENGTH) {
            this[`modal_phone_${i}`] = newValue;
          } else {
            this[`modal_phone_${i}`] = oldValue;
          }
          break;
        default:
          this[`modal_phone_${i}`] = oldValue;
      }
    },

    validEmail: function (email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    async createNewSalesRep() {
      try {
        if (this.checkForm()) {
          this.loading = true;
          let params = {
            name: this.modal_name,
            email: this.modal_email,
            _method: "post",
          };

          if (this.phoneNumber?.length >= 14) {
            params["phone"] = this.phoneNumber;
          }

          await this.addNewSalesRep(params);
          this.$emit("close");
        }
      } catch (error) {
        console.log(error);
        this.$store.dispatch("showToast", {
          txt: "Something went wrong trying to create a new Sales rep. Please try again.",
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },
  },

  mounted() {
    this.modal_name = this.prepopulatedName;
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-container {
  width: 45% !important;
  max-width: 800px !important;
  margin: auto;
  background: white;
  border-radius: 6px;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.2rem;
    border-bottom: 1px solid $grey-light;
    p {
      text-transform: capitalize;
      margin-right: auto;
      margin-left: 0.5rem;
    }
  }

  .content {
    display: flex;
    flex-direction: row !important;
    padding: 1.3rem 1.5rem;
    gap: 2rem;
    p.text {
      color: $grey-dark;
    }

    .form-container {
      width: 50%;
      .input-container {
        width: 100%;
        &.error {
          label {
            color: $redError;
          }
          input,
          textarea,
          .input-style {
            border: 2px solid $redError;
          }

          span {
            color: $redError;
          }

          span.error-msg {
            color: $redError;
            font-size: 0.8em;
            margin-top: 0.25rem;
            text-align: left;
          }
        }

        .sidebar-option-title {
          margin-bottom: 0.75rem;
          display: flex;
          align-items: center;
          text-transform: capitalize;
          width: 100%;
          span {
            margin-right: 1rem;
          }
        }

        .input-style {
          width: 100%;
          padding: 0.75rem;
          background: white;
          border: 1px solid $grey-light;
          border-radius: 6px;

          &.select {
            padding: 0;
            border: none;
            ::v-deep {
              .vs__dropdown-toggle {
                border-radius: 6px;
                border: 1px solid $grey-light;
                padding: 0.5rem;
              }
            }
          }
        }
      }
    }

    .phone-mask-container {
      input {
        width: 30%;
      }
    }
    .show-extension-switch {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }

    .extension-container {
      .input-container {
        display: flex;
        justify-content: space-between;
        label:first-child {
          margin-right: 1rem;
          width: 30%;
        }
      }
    }
    .rep-preview-container {
      width: 50%;
      display: flex;
      flex-flow: column;
      /* justify-content: center; */

      .text-info {
        color: $grey-dark;
        margin-bottom: 1.5rem;

        .rep-info {
          border-left: 1px solid $grey-light;
          padding-left: 1rem;
          h3 {
            margin-bottom: 0.5rem;
          }

          p {
            overflow-wrap: break-word;
          }
        }
      }

      /* .url-container {
      display: flex;
      justify-content: space-between;
      border: 1px solid #eaeaea;
      border-radius: 6px;
      overflow: hidden;
      .url {
        padding: 0.5rem;
        color: $dark;
        text-decoration: underline;
      }

      button {
        background-color: $dark;
        border-radius: 0 !important;
        color: white;
        padding: 0 0.5rem;
      }
    }

    p.msg {
      padding: 0.5rem 0;
      color: $green;
    } */
    }

    .buttons-container {
      display: flex;
      padding: 1.3rem 1.5rem;
      gap: 1rem;
      justify-content: flex-end;
      .btn {
        &.confirm {
          background: $dark;
          display: flex;
          align-items: center;
          color: white;
          text-transform: capitalize;
        }
      }
    }
  }

  @media screen and (max-width: 1440px) {
    width: 50%;
  }
}
</style>
